import axios from "axios";
import QS from "qs";
import router from "@/router";
import { Message } from "element-ui";
import vueThis from "@/main";

const APP_URL = process.env.VUE_APP_BASE_API || "http://192.168.12.93:20000";

const request = axios.create({
  baseURL: APP_URL,
  timeout: 300000,
});

let num = 0;
let lastDownNoticeTime = 0;
const DOWN_NOTICE_INTERVAL = 5 * 1000;
const progressFinish = function () {
  num--;
  if (num === 0) {
    vueThis.$Progress.finish();
  }
};

const progressFail = function () {
  num--;
  if (num === 0) {
    vueThis.$Progress.fail();
  }
};

request.interceptors.request.use(
  (config) => {
    const now = Date.now();
    if (now - lastDownNoticeTime >= DOWN_NOTICE_INTERVAL) {
      lastDownNoticeTime = now;
      Message({
        message: "旧系统即将下线，请使用新系统平台",
        type: "warning",
      });
    }
    num++;
    vueThis.$Progress.start();
    const token = localStorage.getItem("token");
    if (token) {
      // 为所有的请求中设置 token 到请求头中
      config.headers.token = token;
    }
    return config;
  },
  (err) => {
    progressFail();
    return Promise.reject(err);
  }
);

request.interceptors.response.use(
  (response) => {
    console.log(
      `${response.config.baseURL}${response.config.url} ===> `,
      response.data
    );

    if (response.data.status === 1) {
      // 获取数据成功之后还需要对data里面的status的状态码进行判断
      progressFinish();
      return Promise.resolve(response);
    } else {
      progressFail();
      console.log("状态码异常s", response.data.status);
      if (response.data.status) {
        switch (response.data.status) {
          case 1000:
            Message({
              message: response.data.msg || "服务器内部发生错误",
              type: "error",
            });
            break;

          case 1001:
            Message({
              message: response.data.msg || "参数类型不匹配",
              type: "error",
            });
            break;

          case 1002:
            Message({
              message: response.data.msg || "缺少必须的参数",
              type: "error",
            });
            break;

          case 1003:
            Message({
              message: response.data.msg || "不支持的请求类型",
              type: "error",
            });
            break;

          case 1004:
            Message({
              message: response.data.msg || "参数不可序列化或不可读",
              type: "error",
            });
            break;

          case 1005:
            Message({
              message: response.data.msg || "参数不合法",
              type: "error",
            });
            break;

          case 1100:
            Message({
              message: response.data.msg || "业务异常（不符合业务流程要求）",
              type: "error",
            });
            break;

          case 1101:
            Message({
              message: response.data.msg || "频繁操作错误",
              type: "error",
            });
            break;

          case 1102:
            Message({
              message: response.data.msg || "客户端版本过旧",
              type: "error",
            });
            break;

          case 1201:
            Message({
              message: response.data.msg || "TOKEN错误，请重新登录",
              type: "error",
            });
            localStorage.removeItem("token");
            localStorage.removeItem("permissions");
            setTimeout(() => {
              router.replace({
                path: "/login",
                query: {
                  redirect: router.currentRoute.fullPath,
                },
              });
            }, 1000);
            break;

          case 1202:
            Message({
              message: response.data.msg || "没权限访问",
              type: "error",
            });
            break;

          case 1203:
            Message({
              message: response.data.msg || "未登录，需要登录后访问",
              type: "error",
            });
            localStorage.removeItem("token");
            localStorage.removeItem("permissions");
            setTimeout(() => {
              router.replace({
                path: "/login",
                query: {
                  redirect: router.currentRoute.fullPath,
                },
              });
            }, 1000);
            break;

          case 1404:
            Message({
              message: "无该资源，请求了服务器未提供的URI",
              type: "error",
            });
            break;

          default:
            Message({
              type: "error",
              message: response.data.msg || "请求失败，请检查网络！",
              duration: 5 * 1000,
            });
        }
      }
      return Promise.reject(response);
    }
  },
  (err) => {
    if (err.message === "Network Error") {
      Message({
        message: err.message + ",请联系技术人员",
        type: "error",
        duration: 5 * 1000,
      });
      progressFail();
      return Promise.reject(err);
    }
    // 请求错误
    if (err.response) {
      Message({
        message: err.response.data.message || "Error",
        type: "error",
        duration: 5 * 1000,
      });
      progressFail();
      return Promise.reject(err);
    }
  }
);

export function get(url, params) {
  return request({
    url,
    method: "get",
    params: params,
  });
}

export function get1(url, params) {
  return request({
    url,
    method: "get",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
    params: params,
  });
}

export function post(url, params) {
  return request({
    url,
    method: "post",
    data: QS.stringify(params),
  });
}

export function post1(url, params) {
  return request({
    url,
    method: "post",
    data: params,
    headers: {
      "content-type": "application/json",
    },
  });
}

export default request;
